import * as React from 'react'
import * as Client from './shopify_client'

interface IAddVariantToCartArgs {
  cartID: string
  buildCheckoutAttributes: Client.IBuildCheckoutAttributes
  customAttributes: Client.IMappedCustomAttributes
  variantID: string
  quantity: number
}

interface IProps {
  cartID?: string
  buildCheckoutAttributes?: Client.IBuildCheckoutAttributes
  sourceURL?: string
  ministryName?: string
  addVariantToCart: (args: IAddVariantToCartArgs) => Promise<Client.ICart>
  [propName: string]: any
}

interface IState {
  cart?: Client.ICart
}

interface ICheckoutProps {
  addVariantToCart?: (params: Partial<IAddVariantToCartArgs>) => Promise<Client.ICart>,
}

function withCheckout<TProps extends ICheckoutProps, TState>(
  WrappedComponent: new (...args: any[]) => React.Component<TProps, TState>,
) {
  return class extends React.Component<IProps & TProps, IState> {
    private shopifyClient: Client.ShopifyClient

    public constructor(props: any) {
      super(props)

      this.shopifyClient = new Client.ShopifyClient()

      this.state = {}
    }

    public render() {
      const {
        cartID,
        buildCheckoutAttributes,
        sourceURL,
        ministryName,
      } = this.props
      const {
        cart: storedCart,
      } = this.state

      const storeCart = (newCart: Client.ICart) => {
        this.setState({ cart: newCart })
      }

      const passedProps = Object.assign({}, this.props, {
        addVariantToCart: async ({ variantID, quantity }: Partial<IAddVariantToCartArgs>) => {
          const newCart = await this.shopifyClient.addVariantToCart({
            cartID: storedCart ? storedCart.id : cartID,
            buildCheckoutAttributes,
            variantID,
            quantity,
            customAttributes: {
              _sourceURL: sourceURL,
              _ministryName: ministryName,
              _accountID: buildCheckoutAttributes.accountID.toString(),
            },
          })

          storeCart(newCart)

          return newCart
        },
      })

      return <WrappedComponent {...passedProps}/>
    }
  }
}

export { withCheckout }
